import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { getLangProperty, cache } from '@appbase/util';

import UserCardComponent from '@/modules/@appbase/components/common/UserCard/UserCardComponent';

@Component({})
export default class RecommendBox extends UserCardComponent {
  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //
  @Prop({ type: Object }) value!: article.RecommendSet;
  @Prop({ type: String }) userLang!: String;

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //
  userPhoto: string = '';

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //
  langProperty(obj: Object, propKey: string) {
    return getLangProperty(obj, propKey);
  }

  @Watch('value')
  setUserPhoto() {
    cache.avatar.get(this.value.userCode).then(res => {
      this.userPhoto = res;
    });
  }

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y L E : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //
  created() {
    this.setUserPhoto();
  }
}
